import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-starterpage',
  templateUrl: './starterpage.component.html',
  styleUrls: ['./starterpage.component.scss']
})
export class StarterpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
